export default __webpack_public_path__ + "static/media/ic_smiley_face.ce2811bf.svg";